<script lang="ts">
import type { FunctionalComponent } from 'vue'
import { h, useCssModule } from 'vue'

type Props = {
  isEditing?: boolean
  class?: StyleClass
}

const SettingsTable: FunctionalComponent<Props> = (
  props: Props,
  { slots, attrs }
) => {
  const defaultSlot = slots.default?.()
  if (defaultSlot === undefined) {
    return h('dl')
  }
  const children = defaultSlot
    .filter(vnode => vnode.type !== undefined)
    .map(vnode => {
      if (vnode.component === undefined) {
        return vnode
      }
      vnode.props = {
        ...vnode.props,
        ...props,
      }
      return vnode
    })

  const classes = useCssModule()
  const baseClassStr = (attrs.class as string) ?? ''
  const classStr = [...baseClassStr.split(' '), classes.table].join(' ')

  return h('dl', { ...attrs, class: classStr }, children)
}

SettingsTable.props = {
  isEditing: {
    type: Boolean,
    default: false,
  },
  class: {
    type: [String, Object, Array],
    default: null,
  },
}

export default SettingsTable
</script>

<style module lang="scss">
.table {
  display: grid;
  row-gap: 4px;
}
</style>
